// this file is automatically generated by git.version.ts script
export const versions = {version: '1.25.7', revision: 'dab7564', branch: 'development'};
